export default __webpack_public_path__ + "static/media/2025_Ke_et_al_2025_EcologicalMonographs.b61cb8f3.pdf";